import React, {useEffect, useRef} from 'react'
import {Transformer} from 'react-konva'

const CORNER_ANCHORS = ['top-left', 'top-right', 'bottom-left', 'bottom-right']

const SelectionTransformer = ({selection, isOnlySvgShape = false}) => {
    const trRef = useRef(null)

    useEffect(() => {
        const layer = trRef.current?.getLayer()
        if (!layer) return
        const nodes = selection.nodeIds.map((id) => layer.findOne(`#${id}`)).filter(Boolean)
        trRef.current.nodes(nodes)
        layer.batchDraw()
    }, [selection])

    return (
        <Transformer
            ref={trRef}
            rotateEnabled
            resizeEnabled
            keepRatio={isOnlySvgShape}
            enabledAnchors={isOnlySvgShape ? CORNER_ANCHORS : undefined}
        />
    )
}

export default SelectionTransformer
